const ENABLE_MODAL = true;
const LAST_MEP = "06-2025";
const CACHE_KEY = `about-mep-${LAST_MEP}-seen`;

export { CACHE_KEY, ENABLE_MODAL };

